import { createIconComponent } from '../../factory/create-icon-component';
export const ChevronUpIcon = createIconComponent(
  'ChevronUpIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8952 9.32503L16.9248 11.3546C19.0877 13.5175 20.1691 14.5989 20.2422 15.5274C20.3056 16.333 19.9795 17.1203 19.365 17.6451C18.6568 18.25 17.1274 18.25 14.0686 18.25L8.58844 18.25C6.72848 18.25 5.7985 18.25 5.29529 18.0179C4.09932 17.4663 3.52838 16.0879 3.984 14.8521C4.1757 14.3322 4.83329 13.6746 6.14846 12.3594L6.14848 12.3594L9.09377 9.41413L9.18288 9.32503L9.18288 9.32502C10.1826 8.32526 10.6825 7.82539 11.2589 7.6381C11.766 7.47335 12.3121 7.47335 12.8192 7.6381C13.3956 7.82539 13.8955 8.32527 14.8952 9.32503Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
